import cx from "classnames";

import { Menu as AntdMenu, Tooltip } from "antd";

import styles from "../styles/UserDartment.module.css";

function UserDepartment({
  selectedRole,
  roleOptions = [],
  onChange = () => { },
}) {
  const onMenuClick = (e) => {
    const key = e.key;
    onChange(key);
  };

  const enhancedRoleOptions = roleOptions.map((item) => ({
    ...item,
    label: (
      <Tooltip title={item.label} placement="topLeft" overlayInnerStyle={{ color: "black" }} color="white">
        <span>{item.label}</span>
      </Tooltip>
    ),
  }));

  return (
    <AntdMenu
      className={styles.menu}
      defaultSelectedKeys={selectedRole}
      selectedKeys={selectedRole}
      mode="inline"
      items={enhancedRoleOptions}
      onClick={onMenuClick}
    />
  );
}

export default UserDepartment;
